import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IClientService, ICommonStatistics, IMedicalDesk, IStatisticsState, TError } from './types/statistics-interface';
import { fetchCommonStatistics, fetchStatisticsClientService, fetchStatisticsMedicalDesk } from './actions/fetch-statistics';

const initialState: IStatisticsState = {
    MedicalDesk: {
        DoctorRequestAmount: null,
        Convertibility: null,
        DoctorRequestAmountPerPolicy: null,
        IssueResolutionOnFirstDoctorRequest: null,
        AvgTimeResolutionClinicRegistration: null,
        AvgTimeResolutionServiceApproval: null,
        DiagramByCommunicationChannels: [],
        DiagramByTypes: [],
        DiagramBySpecialties: [],
        DiagramByServiceAgreement: [],
        isLoadingStatistics: false,
        errorStatistics: [],
    },
    ClientService: {
        RefusalFrequency: null,
        ApprovalBeyondProgramFrequency: null,
        ComplaintRate: null,
        JustifiedClaimsAmount: null,
        UnJustifiedClaimsAmount: null,
        GratitudesAmount: null,
        isLoadingStatistics: false,
        errorStatistics: [],
    },
    CommonStatistics: {
        InsurancePremium: null,
        InsuredsAmount: null,
        RotationLevel: null,
        isLoadingStatistics: false,
        errorStatistics: [],
    },
    activeRequestsCount: 0,
};

export const Statistics = createSlice({
    name: 'Statistics',
    initialState,
    reducers: {
        resetStatisticsData: (state) => {
            state.MedicalDesk = initialState.MedicalDesk;
            state.ClientService = initialState.ClientService;
            state.CommonStatistics = initialState.CommonStatistics;
            state.activeRequestsCount = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStatisticsMedicalDesk.pending, (state) => {
                state.activeRequestsCount += 1;
                state.MedicalDesk.isLoadingStatistics = true;
            })
            .addCase(fetchStatisticsMedicalDesk.fulfilled, (state, action: PayloadAction<{ Statistics: IMedicalDesk }>) => {
                state.activeRequestsCount -= 1;
                state.MedicalDesk = {
                    ...action.payload.Statistics,
                    isLoadingStatistics: false,
                    errorStatistics: [],
                };
            })
            .addCase(fetchStatisticsMedicalDesk.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.MedicalDesk = {
                    ...initialState.MedicalDesk,
                    isLoadingStatistics: false,
                    errorStatistics: action.payload as TError,
                };
            })
            .addCase(fetchStatisticsClientService.pending, (state) => {
                state.activeRequestsCount += 1;
                state.ClientService.isLoadingStatistics = true;
            })
            .addCase(fetchStatisticsClientService.fulfilled, (state, action: PayloadAction<{ Statistics: IClientService }>) => {
                state.activeRequestsCount -= 1;
                state.ClientService = {
                    ...action.payload.Statistics,
                    isLoadingStatistics: false,
                    errorStatistics: [],
                };
            })
            .addCase(fetchStatisticsClientService.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.ClientService = {
                    ...initialState.ClientService,
                    isLoadingStatistics: false,
                    errorStatistics: action.payload as TError,
                };
            })
            .addCase(fetchCommonStatistics.pending, (state) => {
                state.activeRequestsCount += 1;
                state.CommonStatistics.isLoadingStatistics = true;
            })
            .addCase(fetchCommonStatistics.fulfilled, (state, action: PayloadAction<{ Statistics: ICommonStatistics }>) => {
                state.activeRequestsCount -= 1;
                state.CommonStatistics = {
                    ...action.payload.Statistics,
                    isLoadingStatistics: false,
                    errorStatistics: [],
                };
            })
            .addCase(fetchCommonStatistics.rejected, (state, action) => {
                state.activeRequestsCount -= 1;
                state.CommonStatistics = {
                    ...initialState.CommonStatistics,
                    isLoadingStatistics: false,
                    errorStatistics: action.payload as TError,
                };
            })
    },
});

export const { resetStatisticsData } = Statistics.actions;
export default Statistics.reducer;